import { initItems } from './items';
import { extendDeep } from '../../utils/utils';
import { addEvents } from '../decorators';
import { eventsList } from '../../events/list';
import { initHttp } from '../../utils/http';
import { defaultSettings } from '../private-site/settings';
export function WixVideo(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  const settings = extendDeep(defaultSettings, userSettings);
  const requestOptions = settings.requestOptions;
  const http = initHttp(requestOptions);
  const items = initItems(settings, http);
  this.name = 'wix-video';
  this.items = addEvents(this, eventsList.ITEMS, items);
}